import React from 'react';

import DatePicker from './date_picker';
import Dropdown from './dropdown';
import DateRange from './date_range';

import StepBackwardSolidSVG from '../../www/assets/images/step_backward_solid.svg';
import CalendarAltSolidSVG from '../../www/assets/images/calendar_alt_solid.svg';
import PauseSolidSVG from '../../www/assets/images/pause_solid.svg';
import PlaySolidSVG from '../../www/assets/images/play_solid.svg';
import StepForwardSolidSVG from '../../www/assets/images/step_forward_solid.svg';
import ar from '../languages/ar';

import { eventsStore, refsStore, datasetStore, videoStore } from '../managers/globalState';

import '../../www/assets/css/dataset_tools.css';

class DatasetTools extends React.Component {
	/**
		* @param {HTMLDivElement} div
	*/
	constructor(props) {
		super(props);

		this.datasetToolsRef = this;
		this._dateRangeRef = React.createRef();
		const { showOnGlobe } = eventsStore.stateSnapshot;

		this.state = {
			showAlternateViewsDropdown: true,
			showOnGlobe,
			videoId: null
		};

		// Binds
		this.prevButtonClicked = this.prevButtonClicked.bind(this);
		this.nextButtonClicked = this.nextButtonClicked.bind(this);
		this.onDropdownItemSelect = this.onDropdownItemSelect.bind(this);
		this.calendarButtonClicked = this.calendarButtonClicked.bind(this);
		this.showAlternateViewsDropdown = this.showAlternateViewsDropdown.bind(this);
	}

	// Subscribe to the global showOnGlobe state and set local state to allow component to be reactive.
	componentDidMount() {
    this.eventsUnsubscribe = eventsStore.subscribeTo('showOnGlobe', value => {
			this.setState({ showOnGlobe: value });
		});
		this.videosUnsubscribe = videoStore.subscribeTo('videoId', value => {
			this.setState({ videoId: value });
		});
		this.dsUnsubscribe = datasetStore.subscribeAll(() => this.forceUpdate());
		const { showOnGlobe } = eventsStore.stateSnapshot;
		this.setState({ showOnGlobe });
	}

	// This component doesn't appear to get unmounted, even though it show up conditionally.
	// Nonetheless, we shold follow best practices and call unsubscribe on unmount.
	componentWillUnmount() {
		typeof this.eventsUnsubscribe === 'function' && this.eventsUnsubscribe();
		typeof this.videosUnsubscribe === 'function' && this.videosUnsubscribe();
		typeof this.dsUnsubscribe === 'function' && this.dsUnsubscribe();
	}

	calendarButtonClicked() {
		this.showAlternateViewsDropdown(false);
		const { datePickerRef } = this.props;
		datePickerRef.current.show();
	}

	nextButtonClicked() {
		const { get } = refsStore.stateSnapshot;
		get('dataset').nextDataset();
	}

	prevButtonClicked() {
		const { get } = refsStore.stateSnapshot;
		get('dataset').prevDataset();
	}

	playPauseButtonClicked() {
		const { get } = refsStore.stateSnapshot;
		const { isPaused } = datasetStore.stateSnapshot;
		get('dataset').setPaused(!isPaused);
	}

	onDropdownItemSelect(selectedIndex, text) {
		const { get } = refsStore.stateSnapshot;
		const videoId = get('video').getVideoIdFromTitle(text);

		// Check to see if the selected item has a video associated with it.
		if (videoId) {
			get('route').navigate({
				animating: 'f',
				start: '',
				end: '',
				videoId,
				__remove: ['spacecraft']

			});
		} else {	// It is an alt dataset, not a video.
			get('route').navigate({
				altView: selectedIndex,
				animating: 'f',
				start: '',
				end: '',
				__remove: ['spacecraft', 'videoId']
			});
		}
	}

	showAlternateViewsDropdown(shouldBeShown) {
		this.setState({ showAlternateViewsDropdown: shouldBeShown });
	}

	render() {
		const { get } = refsStore.stateSnapshot;
		let { altid, altView, isMobile, datePickerProps, event, view } = this.props;

		const { datasetGroup, playLatestSeven } = get('dataset');
		const { vitalData, isSatellitesNow } = get('content');
		const { showAlternateViewsDropdown, showOnGlobe, videoId } = this.state;
		const { hasAnimation, isPaused } = datasetStore.stateSnapshot;
		if (videoId || showOnGlobe || vitalData === null || isSatellitesNow || view == "event" || view == "poi" || view == "gmap" || !datasetGroup) {
			return null;
		}

		// TODO: Move this to app (update url)
		if ((vitalData.datasetGroups.length - 1) < altid) {
			altid = 0;
		}
		const { datasets: allDatasets } = datasetGroup;

		const allDropDownEntries = [];

		// Add dataset ids and videos related to this vital sign to the dropDownEntries array
		allDropDownEntries.push(...allDatasets);
		allDropDownEntries.push(...get('video').getVideoDropdownEntries(vitalData.value));

		const showDropdown = !isMobile && allDropDownEntries.length > 1 && showAlternateViewsDropdown;

    const dataset_menu_items = allDropDownEntries.map((v,i) => {
      return {
        id: v.id,
        text: v.menuTitle
      }
    })
		const dropdownComponent = showDropdown
			? (
				<Dropdown
					itemIndex={altView}
					onItemClick={this.onDropdownItemSelect}
					itemList={dataset_menu_items}
				/>
			) :
			null;
		
		let animateContainer = null;
		if (!isMobile) {
			animateContainer = (
				<div id='dataset-tools'>
					<div className='container alt-views-dropdown-container'>
						{dropdownComponent}
					</div>
					<div className='d-none d-lg-block mb-lg-5 mr-lg-3 mr-lg-5 animate-button-container'>
						<button className='animate no-select' onClick={playLatestSeven}>{ar.animate_this_data}</button>
					</div>
				</div>
			);
		}

		const controlsContainer = (
			<>
				<div id='dataset-tools'>
					<div className=' alternate-views'>
						{dropdownComponent}
					</div>
					<div className='controls'>
						<button className='controls-btn previous no-select' type='button' onClick={this.prevButtonClicked}>
							<StepBackwardSolidSVG />
						</button>
						<button className='controls-btn playpause no-select' type='button' onClick={this.playPauseButtonClicked}>
							{ isPaused ? <PlaySolidSVG /> : <PauseSolidSVG /> }
						</button>
						<button className='controls-btn next no-select' type='button' onClick={this.nextButtonClicked}>
							<StepForwardSolidSVG />
						</button>
						{
							!isMobile
							&& (
								<button className='controls-btn calendar-toggle no-select' type='button' onClick={this.calendarButtonClicked}>
									<CalendarAltSolidSVG />
								</button>
							)
						}
					</div>
					{!isMobile && (
						<div className='range'>
							<DateRange />
						</div>
					)}
				</div>
				{
					!isMobile
					&& (
						<DatePicker
							{...datePickerProps}
							showAlternateViewsDropdown={this.showAlternateViewsDropdown}
						/>
					)
				}

			</>
		);

		return hasAnimation ? controlsContainer : animateContainer;
	}
}

export default DatasetTools;
